const { SpaceServicePromiseClient } = require("./SpaceService_grpc_web_pb.js");

//console.log("Space server: " + process.env.REACT_APP_SPACE_SERVER)

const spaceClient = new SpaceServicePromiseClient(process.env.REACT_APP_SPACE_SERVER);

export default spaceClient;